import React from 'react'
import ScroolTop from '../tools/ScroolTop'
import Footer from '../tools/Footer'
import BarHorizontale from '../tools/BarHorizontale'
import DatatableRecherche from '../tools/recherche/DatatableRecherche'

function Recherche({users, recherche, announcements}) {
  return (
    <>
      <div className="d-flex flex-column" id="content-wrapper">
          <div id="content">
              <BarHorizontale />
              <div className="container-fluid">
                  <h3 className="text-dark mb-4">Gestion des recherches</h3>
                  <div className="card shadow">
                      <div className="card-header py-3">
                        <p className="text-primary m-0 fw-bold titre1">Les recherches</p>
                      </div>
                      <div className="card-body">
                        <DatatableRecherche users={users} recherche={recherche}/>
                      </div>
                  </div>
              </div>
          </div>
          <Footer/>
      </div>
      <ScroolTop />
    </>
  )
}

export default Recherche